/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Select_Previous_EventInputs */



/**
* | output |
* | --- |
* | "Select the previous event in the list" |
*
* @param {Shortcut_Keys_Desc_Select_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_select_previous_event = /** @type {((inputs?: Shortcut_Keys_Desc_Select_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Select_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner l'evenement precedent dans la liste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie das vorherige Ereignis in der Liste aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona l'evento precedente nell'elenco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите предыдущее событие в списке.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el evento anterior en la lista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在列表中选择上一个事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リスト内の前のイベントを選択する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सूची में से पिछली घटना का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o evento anterior na lista.")
	return /** @type {LocalizedString} */ ("Select the previous event in the list")
});